<template>
  <div>
    <b-modal id="modalEditTrafficCollectorsSetting" ref="modalEditTrafficCollectorsSetting" :title="$t('Traffic collector')" hide-footer @shown="shown">
      <div v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.collector_id != -1" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.collector_id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.collector_id == 0" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.collector_id == 0" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.comments"/>
        </b-form-group>
        <b-form-group label-align="right" v-if="editItem.collector_id != -1" :label="$t('Uptime')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="trafficCollectorsStats.uptime" disabled/>
        </b-form-group>
        <b-form-group label-align="right" v-if="editItem.collector_id != -1" :label="$t('NetFlow records')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="trafficCollectorsStats.nf_records_count" disabled/>
        </b-form-group>
        <b-form-group label-align="right" v-if="editItem.collector_id != -1" :label="$t('NetFlow error records')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="trafficCollectorsStats.nf_errors_count" disabled/>
        </b-form-group>
        <b-button variant="secondary" size="sm" @click="properties" v-if="editItem.collector_id != -1">{{ $t('Properties')}}</b-button>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditTrafficCollectorsSetting.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal ref="modalProperties" :title="$t('Traffic collector settings')" hide-footer size="lg">
      <b-form-group label-align="right" v-for="item in registrySettingsEdit" :key="item.setting_id" :label="$t(item.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <div v-if="item.raw_values.length">
          <b-form-input v-if="isInput(item)" :type="getInputType(item)" v-model="item.raw_values[0].value"/>
        </div>
      </b-form-group>

      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveProperties">{{ $t('Save')}}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalProperties.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    saveProperties () {
      for (let elEdit of this.registrySettingsEdit) {
        for (let el of this.registrySettings) {
          if (el.setting_id === elEdit.setting_id) {
            if (el.raw_values[0].value !== elEdit.raw_values[0].value) {
              elEdit.object_id = this.editItem.collector_id
              this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', elEdit).then(response => {
                if (response.data.error) {
                  this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
                } else {
                  this.$root.$emit('makeToasts')
                }
              })
            }
            this.$refs.modalProperties.hide()
            break
          }
        }
      }
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      let response = this.editItem.collector_id !== -1
        ? this.$store.dispatch('Settings/UPDATE_TRAFFIC_COLLECTORS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_TRAFFIC_COLLECTORS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_TRAFFIC_COLLECTORS')
          this.$refs.modalEditTrafficCollectorsSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    properties () {
      this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 1, object_id: this.editItem.collector_id})
      this.$refs.modalProperties.show()
    },
    isInput (item) {
      return [1, 2, 3, 4, 5].includes(item.value_type)
    },
    getInputType (item) {
      switch (item.value_type) {
        case 1:
          return 'number'
        case 2:
          return 'number'
        case 3:
          return 'number'
        case 4:
          return 'text'
        case 5:
          return 'text'
        default:
          return 'text'
      }
    },
    shown () {
      this.$store.dispatch('Settings/GET_TRAFFIC_COLLECTORS_STATS', this.editItem.collector_id)
    }
  },
  computed: {
    registrySettings () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS']
    },
    registrySettingsEdit () {
      return JSON.parse(JSON.stringify(this.$store.getters['Settings/REGISTRY_SETTINGS']))
    },
    trafficCollectorsStats () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/TRAFFIC_COLLECTORS_STATS']))
      copy.uptime = Math.floor(copy.uptime / 86400) + (' days, ') +
      Math.floor((copy.uptime % 86400) / 3600) + (':') +
      Math.floor(((copy.uptime % 86400) % 3600) / 60) + (':') +
      (((copy.uptime % 86400) % 3600) % 60)
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/inventory/trafficCollectors/editModal.vue